/**
 * Frontend Enum
 * 서버에 대응 enum 이 없는 클라 전용 열거형
 */
const FrontendEnum = {
    /**
     * 부서 받은 요청 '유형' 필터 (클라 전용)
     */
    FE_DOCUMENT_RECEIVED_TYPE: {
        DOC_APPROVER: "DOC_APPROVER",
        SEAL_APPROVER: "SEAL_APPROVER",
        SEAL_MANAGER: "SEAL_MANAGER",
    },

    /**
     * 날짜 입력 폼이 값을 보관·직렬화하는 형식 (클라 전용)
     */
    FE_DATE_COMMUNICATION: {
        DATE: "YYYYMMDD",
        DATE_TIME: "YYYYMMDDHHmmss",
        ISO: "iso",
        UNIX: "unix",
    },
};

export default FrontendEnum;
